import { ethers } from 'ethers';
export { checkProperties, deepCopy, defineReadOnly, getStatic, resolveProperties, shallowCopy } from '@ethersproject/properties';

const encodeMessageDigest = message => {
  if (typeof message === 'string') {
    return ethers.utils.arrayify(ethers.utils.keccak256(ethers.utils.toUtf8Bytes(message)));
  } else {
    return ethers.utils.arrayify(ethers.utils.keccak256(message));
  }
};

const isNode = () => {
  if (typeof window === 'undefined' && typeof process === 'object') {
    return true;
  } else {
    return false;
  }
};
const isBrowser = () => !isNode();

function promisify(f, thisContext) {
  return function (...a) {
    const args = Array.prototype.slice.call(a);
    return new Promise(async (resolve, reject) => {
      try {
        args.push((err, result) => err ? reject(err) : resolve(result));
        await f.apply(thisContext, args);
      } catch (e) {
        reject(e);
      }
    });
  };
}

const getRandomInt = (min = 0, max = Number.MAX_SAFE_INTEGER) => {
  min = Math.ceil(min);
  max = Math.floor(max);
  return Math.floor(Math.random() * (max - min + 1)) + min;
};

// sanitizeNumberString accepts a number string and returns back a clean number string.
// For example, input '1234.5678' will return '1234.5678' but '12javascript:{}etc' will return '12'
const sanitizeNumberString = numString => {
  if (!numString || typeof numString !== 'string') {
    return '';
  }

  const v = numString.match(/[\d.]+/);
  return v && v.length > 0 ? v[0] : '';
};

const sleep = t => {
  return new Promise(resolve => {
    const timeout = setTimeout(() => {
      clearTimeout(timeout);
      resolve();
    }, t);
  });
};

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

const encodeTypedDataHash = typedData => {
  const types = _extends({}, typedData.types); // remove EIP712Domain key from types as ethers will auto-gen it in
  // the hash encoder below


  delete types['EIP712Domain'];
  return ethers.utils.arrayify(ethers.utils._TypedDataEncoder.hash(typedData.domain, types, typedData.message));
};
const encodeTypedDataDigest = typedData => {
  const hash = encodeTypedDataHash(typedData);
  const digest = ethers.utils.arrayify(ethers.utils.keccak256(hash));
  return digest;
};

// urlClean removes double slashes from url path
const urlClean = url => url.replace(/([^:]\/)\/+/g, '$1');

export { encodeMessageDigest, encodeTypedDataDigest, encodeTypedDataHash, getRandomInt, isBrowser, isNode, promisify, sanitizeNumberString, sleep, urlClean };
